var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "content" } }, [
    _c("section", { attrs: { id: "password_input" } }, [
      _c("div", { staticClass: "input_list" }, [
        _c("ul", [
          _c("li", [
            _c("div", [
              _c("span", { staticClass: "list_key" }, [
                _vm._v(_vm._s(_vm.label.password))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "important small_text" }, [
                _vm._v("必須")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "small_p" }, [
                _vm._v(
                  "半角英小文字、数字を含む8文字以上の20字以下のパスワードを設定してください。"
                )
              ])
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.passwordForm.password,
                  expression: "passwordForm.password",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "list_box",
              attrs: {
                type: "password",
                placeholder: "********",
                maxlength: "20"
              },
              domProps: { value: _vm.passwordForm.password },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.passwordForm,
                    "password",
                    $event.target.value.trim()
                  )
                },
                blur: function($event) {
                  _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.password
              ? _c("div", { staticClass: "error_text" }, [
                  _vm._v(_vm._s(_vm.errors.password))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", [
              _c("span", { staticClass: "list_key" }, [
                _vm._v(_vm._s(_vm.label.confirmPassword))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "important small_text" }, [
                _vm._v("必須")
              ])
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.passwordForm.confirmPassword,
                  expression: "passwordForm.confirmPassword",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "list_box",
              attrs: {
                type: "password",
                placeholder: "********",
                maxlength: "20"
              },
              domProps: { value: _vm.passwordForm.confirmPassword },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.passwordForm,
                    "confirmPassword",
                    $event.target.value.trim()
                  )
                },
                blur: function($event) {
                  _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _vm.errors.confirmPassword
              ? _c("div", { staticClass: "error_text" }, [
                  _vm._v(_vm._s(_vm.errors.confirmPassword))
                ])
              : _vm._e()
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    Object.keys(_vm.errors).length > 0
      ? _c("div", { staticClass: "error_text" }, [
          _vm._v(
            "入力内容にエラーがあります。項目をご確認の上、もう一度入力してください。"
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ba2a8afe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba2a8afe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/components/user/DcPasswordInput.vue
// module id = null
// module chunks = 